import { render, staticRenderFns } from "./FiltroResultadosPesquisa.vue?vue&type=template&id=352cd412&"
import script from "./FiltroResultadosPesquisa.vue?vue&type=script&lang=js&"
export * from "./FiltroResultadosPesquisa.vue?vue&type=script&lang=js&"
import style0 from "./FiltroResultadosPesquisa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports